// extracted by mini-css-extract-plugin
module.exports = {"root":"preorder-box-module--root--3_BxC","title":"preorder-box-module--title--d91bA","subTitle":"preorder-box-module--sub-title--2uJuP"};